import { Component, OnInit, Input } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { WelcomePackageService } from '../../welcome-package.service'

const PAGE_SIZE = 50
@Component({
  standalone: false,
  selector: 'vs-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
})
export class SearchResultComponent implements OnInit {
  @Input() dataSource: any
  isLoadMoreInProgress = false
  currentPage = 0
  totalPages: any
  totalResult
  id
  full: boolean = true
  totalSearch_excel: any
  displayedColumns: any
  soFlag
  searchType
  constructor(
    private readonly router: Router,
    private readonly welcomePackageService: WelcomePackageService,
    private route: ActivatedRoute,
    protected globalMessageService: GlobalMessageService
  ) {}

  ngOnInit(): void {
    this.soFlag = sessionStorage.getItem('flag')
    this.searchType = sessionStorage.getItem('searchType')
    if (this.dataSource.pagination !== undefined) {
      this.currentPage = this.dataSource.pagination.currentPage
      this.totalPages = this.dataSource.pagination.totalPages
      this.totalSearch_excel = this.dataSource.pagination.totalResults
    } else {
      this.currentPage = 0
      this.totalPages = 0
      this.totalSearch_excel = 0
    }
    this.totalResult = this.dataSource.pagination.totalResults
    this.dataSource = this.dataSource.serialNumberSearchList
    if (this.dataSource) {
      this.displayedColumns = [
        'Serial Number',
        'Part Number',
        'Part Description',
        'Sales Order Reference',
        'Purchase Order Reference',
      ]
    }
    this.route.paramMap.subscribe((value: any) => {
      this.id = value.params.id
    })
  }

  selectedItem(element) {
    this.welcomePackageService.bomData(element.serialNumber, element.recSource)
    sessionStorage.setItem('partNo', element.partNumber)
    sessionStorage.setItem('partDes', element.partDescription)
    sessionStorage.setItem('salesOrder', element.salesOrderRef)
    this.router.navigate([
      '/welcome-package/bom',
      element.serialNumber,
      element.recSource,
    ])
  }

  currentlyLoading: boolean = false

  loadMoreOrders() {
    // on reaching bottom load previous 6 month order
    if (this.isLoadMoreInProgress) {
      return
    }
    if (this.currentlyLoading) {
      return
    }

    this.currentlyLoading = true

    let crntPage = this.currentPage
    crntPage++
    if (crntPage <= this.totalPages - 1) {
      //check if current page is equal to the last page then dnt make a call
      this.welcomePackageService
        .getSearchResult(this.id, crntPage, PAGE_SIZE, this.searchType)
        .subscribe(
          (res: any) => {
            if (res !== null && res !== undefined) {
              this.isLoadMoreInProgress = false
              if (res.pagination !== undefined) {
                this.currentPage = res.pagination.currentPage
                this.totalPages = res.pagination.totalPages
                this.totalSearch_excel = res.pagination.totalResults
              } else {
                this.currentPage = 0
                this.totalPages = 0
                this.totalSearch_excel = 0
              }

              if (
                res.serialNumberSearchList &&
                res.serialNumberSearchList.length
              ) {
                this.dataSource = this.dataSource.concat(
                  res.serialNumberSearchList
                )
              }
              this.currentlyLoading = false
            } else {
              this.isLoadMoreInProgress = false
              this.currentlyLoading = false
              this.globalMessageService.add(
                { key: 'welcomePackage.issueInOrderList' },
                GlobalMessageType.MSG_TYPE_ERROR,
                5000
              )
              window.scrollTo(0, 0)
            }
          },
          (err) => {
            this.isLoadMoreInProgress = false
            this.currentlyLoading = false
            this.globalMessageService.add(
              { key: 'welcomePackage.issueInOrderList' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    } else {
      this.isLoadMoreInProgress = false
      this.currentlyLoading = false
    }
  }
}
